<template>
  <b-container fluid id="gcash-payment-page">
    <b-row>
      <b-col md="6" id="order-summary-section">
        <b-row>
          <b-col md="10" class="mx-auto">
            <div class="h2 mb-3">Order Summary</div>
            <template v-if="paymongoType === 'gcash'">
              <div id="gcash-logo">
                <img
                  src="@/assets/images/gcash.png"
                  class="img-fluid"
                  alt="GCash"
                />
              </div>
              <span class="h4 ml-3 align-middle">GCash</span>
            </template>
            <template v-if="paymongoType === 'grabpay'">
              <div id="grabpay-logo" class="align-middle">
                <img
                  src="@/assets/images/grabpay.png"
                  class="img-fluid"
                  alt="GrabPay"
                />
              </div>
              <span class="h4 ml-3 align-middle">GrabPay</span>
            </template>
          </b-col>
        </b-row>
        <b-row v-if="orderDetails">
          <b-col>
            <!-- VISIBLE ON EXTRA SMALL TO SMALL SCREEN START -->
            <div class="d-md-none">
              <b-row class="my-3">
                <b-col>
                  <b-row class="pb-1">
                    <b-col class="font-weight-bold">Total Amount </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="h4"
                        >&#8369;
                        {{ orderDetails.computed_total | currency }}</span
                      >
                    </b-col>
                    <b-col class="position-relative">
                      <div
                        v-b-toggle.collapase-order-summary
                        class="chevron-toggle"
                      >
                        <img
                          src="@/assets/images/chevron-up.png"
                          alt="Chevron Up"
                          class="chevron-icon when-opened"
                        />
                        <img
                          src="@/assets/images/chevron-down.png"
                          alt="Chevron Down"
                          class="chevron-icon when-closed"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-collapse id="collapase-order-summary" class="mt-3">
                    <hr />
                    <div
                      v-for="(order, index) in orderDetails.orders"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <div
                          class="font-weight-bold text-truncate collapse-branch"
                        >
                          {{ order.brand_name }}
                        </div>
                        <div>{{ order.order_items.length }} item(s)</div>
                        <div class="font-weight-bold">
                          &#8369;{{ order.order_amount | currency }}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div
                      v-if="
                        orderDetails.voucher_code && orderDetails.voucher_amount
                      "
                    >
                      <div class="d-flex justify-content-between">
                        <div class="font-weight-bold text-truncate">
                          Discount
                          <div>({{ orderDetails.voucher_code }})</div>
                        </div>
                        <div class="font-weight-bold">
                          - &#8369;{{ orderDetails.voucher_amount | currency }}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <template v-if="orderDetails.fees.length > 0">
                      <div
                        v-for="(fee, feeIndex) in orderDetails.fees"
                        :key="`fee_${feeIndex}`"
                      >
                        <div class="d-flex justify-content-between">
                          <div
                            class="
                              font-weight-bold
                              text-truncate
                              collapse-branch
                              text-capitalize
                            "
                          >
                            {{ fee.name.replace(/_/g, " ") }}
                          </div>
                          <div></div>
                          <div class="font-weight-bold">
                            &#8369;{{ fee.calculated_amount | currency }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-collapse>
                </b-col>
              </b-row>
            </div>
            <!-- VISIBLE ON EXTRA SMALL TO SMALL SCREEN -->
            <!-- VISIBLE ON MEDIUM AND ABOVE SCREEN START -->
            <div class="d-none d-md-block">
              <b-row>
                <b-col md="10" class="mx-auto">
                  <hr />
                </b-col>
              </b-row>
              <div v-for="(order, index) in orderDetails.orders" :key="index">
                <b-row>
                  <b-col md="10" class="mx-auto">
                    <b-row>
                      <b-col class="font-weight-bold">
                        {{ order.brand_name }}
                      </b-col>
                      <b-col> {{ order.order_items.length }} item(s) </b-col>
                      <b-col class="font-weight-bold text-right">
                        &#8369;{{ order.order_amount | currency }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="10" class="mx-auto">
                    <hr />
                  </b-col>
                </b-row>
              </div>
              <div
                v-if="orderDetails.voucher_code && orderDetails.voucher_amount"
              >
                <b-row>
                  <b-col md="10" class="mx-auto">
                    <b-row>
                      <b-col class="font-weight-bold">
                        Discount ({{ orderDetails.voucher_code }})
                      </b-col>
                      <b-col></b-col>
                      <b-col class="font-weight-bold text-right">
                        - &#8369;{{ orderDetails.voucher_amount | currency }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="10" class="mx-auto">
                    <hr />
                  </b-col>
                </b-row>
              </div>
              <template v-if="orderDetails.fees.length > 0">
                <b-row
                  v-for="(fee, feeIndex) in orderDetails.fees"
                  :key="`fee_${feeIndex}`"
                >
                  <b-col md="10" class="mx-auto">
                    <b-row>
                      <b-col class="font-weight-bold text-capitalize">
                        {{ fee.name.replace(/_/g, " ") }}
                      </b-col>
                      <b-col> </b-col>
                      <b-col class="font-weight-bold text-right">
                        &#8369;{{ fee.calculated_amount | currency }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="10" class="mx-auto">
                    <hr />
                  </b-col>
                </b-row>
              </template>
              <b-row>
                <b-col md="11" class="text-right h5"> Total Amount </b-col>
              </b-row>
              <b-row>
                <b-col md="11" class="text-right h2">
                  PHP {{ orderDetails.computed_total | currency }}
                </b-col>
              </b-row>
            </div>
            <!-- VISIBLE ON MEDIUM AND ABOVE SCREEN END -->
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6" id="card-details-section">
        <b-row id="card-details-form">
          <b-col md="10" class="mx-auto">
            <div class="h4 mt-md-5">Billing Details</div>
            <b-container>
              <b-row class="mt-3 border border-bottom-0 rounded-top p-2">
                <b-col class="px-0 font-weight-bold"> Full Name </b-col>
                <b-col class="px-0 text-right">
                  {{ `${form.firstName} ${form.lastName}` }}
                </b-col>
              </b-row>
              <b-row class="border p-2">
                <b-col class="px-0 font-weight-bold"> Contact Number </b-col>
                <b-col class="px-0 text-right">
                  {{ form.mobileNumber }}
                </b-col>
              </b-row>
              <b-row class="border border-top-0 rounded-bottom p-2">
                <b-col class="px-0 font-weight-bold"> Email </b-col>
                <b-col class="px-0 text-right text-truncate">
                  {{ form.email }}
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-form-invalid-feedback :state="validate('errors')">
                    {{ displayError("errors") }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col md="10" class="mx-auto">
                  <b-button
                    class="
                      btn-core
                      border-0
                      d-inline-flex
                      align-items-center
                      justify-content-center
                    "
                    @click="onCompletePayment"
                    :style="{
                      backgroundColor: `${design.main_color} !important`,
                      color: `${design.button_text_color} !important`
                    }"
                    block
                    :disabled="loading"
                  >
                    {{
                      `${
                        loading
                          ? "Proceeding... Please wait."
                          : "PROCEED TO PAYMENT"
                      }`
                    }}
                    <span
                      class="spinner d-inline-block ml-2"
                      v-if="loading"
                    ></span>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
        <b-row id="card-details-footer">
          <b-container class="px-4">
            <b-row class="mt-3">
              <b-col class="d-flex justify-content-between">
                <div>
                  <img src="@/assets/images/lock.png" id="lock" alt="Secured" />
                  <small class="text-white align-middle ml-1">
                    Secured Payment
                  </small>
                </div>

                <div>
                  <small class="text-white align-middle"> Powered by </small>
                  <img
                    src="@/assets/images/paymongo-green.png"
                    id="paymongo"
                    alt="Secured"
                  />
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "PayMongoPayment",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: ""
      }
    };
  },
  computed: {
    ...mapState("merchant", ["customerPortalToken", "subdomain"]),
    ...mapState("estore", ["orderDetails", "errors", "payMongoData"]),
    ...mapGetters("estore", ["design", "loading"]),
    ...mapGetters("customer", ["customerToken"]),
    paymongoType: {
      get() {
        return this.$route.params.paymongo_type;
      }
    }
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2
      }).format(Number.parseFloat(value).toFixed(2));
    }
  },
  methods: {
    async getOrderDetails(id) {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        tracking_uuid: id
      };
      await this.$store.dispatch("estore/getOrderDetails", request);

      if (!this.orderDetails) this.$router.push({ name: "404" });
    },
    formatExpiryDate(event) {
      event.target.value = event.target.value
        .replace(/[^0-9]/g, "")
        .replace(/^([2-9])$/g, "0$1")
        .replace(/^(1{1})([3-9]{1})$/g, "0$1/$2")
        .replace(/^0{1,}/g, "0")
        .replace(/^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, "$1/$2");
    },
    validate(key) {
      if (this.errors && key in this.errors) return false;

      return null;
    },
    displayError(key) {
      if (this.errors && key in this.errors) {
        if (key === "errors") {
          const { errors } = this.errors;

          if (errors.data && errors.data[0]) {
            const error = errors.data[0].detail
              .replace("details.", "")
              .replace("_", " ");

            return error[0].toUpperCase() + error.slice(1);
          }

          if (errors.message && !errors.data) return errors.message;
        }

        return Array.isArray(this.errors[key])
          ? this.errors[key].join(" ")
          : this.errors[key];
      } else return "";
    },
    async onCompletePayment() {
      const request = {
        header: {
          Authorization: this.customerToken,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          billing_details: {
            firstname: this.form.firstName,
            lastname: this.form.lastName,
            email: this.form.email,
            phone: this.form.mobileNumber
          },
          order_transaction_no: this.orderDetails.transaction_no,
          redirect: {
            success: `${
              window.location.host.includes("http://")
                ? window.location.host
                : `http://${window.location.host}`
            }/${this.subdomain}/checkout/payment/success?orderId=${
              this.$route.query.orderId
            }&token=${this.customerToken}`,
            failed: `${
              window.location.host.includes("http://")
                ? window.location.host
                : `http://${window.location.host}`
            }/${this.subdomain}/checkout/payment/failed?orderId=${
              this.$route.query.orderId
            }&checkoutId=${this.$route.query.checkoutId}&token=${this.customerToken}`
          },
          type: this.paymongoType === "grabpay" ? "grab_pay" : this.paymongoType
        }
      };
      await this.$store.dispatch("estore/payViaPayMongo", request).then(() => {
        window.open(this.payMongoData.data.checkout_url, "_self");
      });
    }
  },
  created() {
    const {
      orderId,
      token,
      firstName,
      lastName,
      mobileNumber,
      email
    } = this.$route.query;

    if (
      !orderId ||
      (!this.customerToken && !token) ||
      !firstName ||
      !lastName ||
      !mobileNumber ||
      !email
    ) {
      this.$router.push({ name: "Home" });

      return;
    }

    // if (token) this.$store.commit("auth/SET_TOKEN", token);

    this.form.firstName = firstName;
    this.form.lastName = lastName;
    this.form.mobileNumber =
      token || mobileNumber.length < 11 ? `0${mobileNumber}` : mobileNumber;
    this.form.email = email;
    this.getOrderDetails(orderId);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/views/checkout/_gcash-payment.scss";
</style>
